// Glide Slider
import Glide from '@glidejs/glide'

// Mobile Menu and Hamburger Button
const hamburgerMenu = document.getElementById('hamburger-menu');
const mainMenu = document.getElementById('main-menu');
const appHeader = document.querySelector('header');

// Fixes a glitch that shows the menu before hiding it on first page load - for mobile only
if (window.innerWidth < 769) {
  mainMenu.style.display = 'none';
}

const toggleMobileMenu = () => {
  mainMenu.removeAttribute('style');

  setTimeout(() => {
    appHeader.classList.toggle('fixed');
    hamburgerMenu.classList.toggle('open');
    mainMenu.classList.toggle('open');
  }, 1);
};

// Adding Listeners (Mobile Only)
if (window.innerWidth < 769) {
  hamburgerMenu.addEventListener('click', toggleMobileMenu);
}

// Starting Glide Slider
const glide = new Glide('.glide', {
  type: 'carousel',
  perView: 6,
  focusAt: 'center',
  // autoplay: 4000,
  hoverpause: true,
  gap: 20,
  breakpoints: {
    800: {
      perView: 3,
    },
    1200: {
      perView: 4,
    },
  },
});

glide.mount();

// Adding footer's copyright year
document.getElementById('copyright_year').innerHTML = new Date().getFullYear();
